// import {
//     Calendar
// } from "@fullcalendar/core";
// import interactionPlugin from "@fullcalendar/interaction";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import timeGridPlugin from "@fullcalendar/timegrid";
// import listPlugin from "@fullcalendar/list";
// import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
// import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";

// import {Draggable} from "fullcalendar-scheduler";

/**
 * 車両予約ページ用のスクリプト
 */
if (is_route('vehicle_reservation.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function () {
        vehicle_reservation_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.vehicle_reservation_event_set = function ()
{
    // ------------------------------
    // fullCalendar(配車板timeline)部制御
    // ------------------------------
    var timeline = {

        /*---- properties ----*/
        _calendarId: 'vehicle_reservation-calendar',    // 生成要素
        _calendar: {},                          // カレンダーobject
        _calendarEl: [],                        // カレンダー要素
        _currentDate: new Date().toISOString(),             // カレント日付
        _currentView: 'resourceTimelineDay',    // カレントVIEW
        _external: null,                        // 外部ドラッグイベントobject
        _scrollX: -1,                           // スクロール位置横
        _scrollY: -1,                           // スクロール位置縦
        _initOptions: {                         // calendar Option
            slotMinWidth: 10,
            eventMinWidth: 10,
            editable: true,
            selectable: true,
            nowIndicator: true,
            initialView: 'resourceTimelineDay',
            initialDate: new Date().toISOString(),
            views: {
                resourceTimelineDay: {
                    resourceAreaWidth: "12%",
                    slotDuration: '00:30:00',
                },
                resourceTimelineWeek: {
                    slotLabelInterval: {hours: 6},
                    slotDuration: '2:00:00',
                    resourceAreaWidth: "12%",
                    slotMinWidth: 13,
                    eventMinWidth: 2,
                },
            },
            headerToolbar: {
                left: 'prev,today,next',
                center: 'title',
                right: 'resourceTimelineDay,resourceTimelineWeek',
            },
        },

        /*---- カレンダー生成 ----*/
        setCalender: function() {
            // set selector
            timeline._calendarEl = $('#' + timeline._calendarId);
            // escape when not selector
            if (timeline._calendarEl.length === 0) {
                return;
            }
            // init option
            timeline._initOptions.initialView = timeline._currentView;
            timeline._initOptions.initialDate = timeline._currentDate;

            // create fullCalendar object
            timeline._calendar = fullCalendar(timeline._calendarId,
                extend_url_query(timeline._calendarEl.data('resource')),    // resourceURL
                extend_url_query(timeline._calendarEl.data('event')),       // eventURL
                timeline._calendarEl.data('content_header'),                // resourceHeaderText
                timeline._initOptions
            );

            // set option
            timeline.setOption();

            // rendering
            timeline._calendar.render();
        },

        /*---- set option ----*/
        setOption: function() {
            // let externalEl = $('#external-draggable');  // 外部ドラッグ対象リスト

            /* setting draggable(リソースをまたいでの制御は、eventデータのconstrainで指定) */
            // 乗務員：同一会社所属、車両：同一会社所属リソースに対してdraggable=trueとなる
            timeline._calendar.setOption('eventResourceEditable', true);

            /* view */
            /* keep scroll position */
            timeline._calendar.setOption('scrollTimeReset', false);
            timeline._calendar.setOption('viewDidMount', function (view) {
                if(timeline._scrollX >= 0 || timeline._scrollY >= 0) {
                    setTimeout(function () {
                        document.querySelector('.fc-timeline-header').parentNode.scrollLeft = timeline._scrollX;
                        document.querySelector('.fc-timeline-slots').parentNode.parentNode.scrollTo(timeline._scrollX, timeline._scrollY);
                    }, 300);
                }
            });

            /* group by section_id when not alone */
            if (!timeline._calendarEl.data('is_one_section')) {
                // every section_id
                timeline._calendar.setOption('resourceGroupField', 'section_id');
                // edit section label
                timeline._calendar.setOption('resourceGroupLabelContent', function (arg) {
                    let arr = Object.values(timeline._calendar.currentData.resourceStore);
                    let result = arr.filter(function (resource) {
                        return arg.groupValue === resource.extendedProps.section_id;
                    });
                    let groupName = result.length > 0 ? result[0].extendedProps.section_name : '';
                    return {html: `<strong>${groupName}</strong> `};
                });
            }

            /* control event */
            // initial popover
            timeline._calendar.setOption('eventDidMount', function (eventObj) {
                // 静止状態で初期化
                if (eventObj.isEnd && (!eventObj.isDragging && !eventObj.isResizing)) {
                    $(eventObj.el).popover({
                        content: eventObj.event.extendedProps.description,
                        trigger: 'hover',
                        placement: 'auto',
                        container: 'body',
                        html: true
                    });
                }
            });
            // escape when not editable
            if (!timeline._initOptions.editable) {
                return;
            }
            // select
            timeline._calendar.setOption('select', function (eventObj) {
                // close popover
                $(eventObj.el).popover('hide');
                // open setting modal
                let data = {
                    id: null,
                    // resource_id: eventObj.resource._resource.id,
                    start: eventObj.startStr,
                    end: eventObj.endStr,
                    section_id: (eventObj.resource) ? eventObj.resource._resource.extendedProps.section_id : null,
                    section_name: (eventObj.resource) ? eventObj.resource._resource.extendedProps.section_name : null,
                };
                if ($('#search-form-mode_user').hasClass('active')) {
                    data.user_id = (eventObj.resource) ? eventObj.resource._resource.id : null;
                    data.user_name = (eventObj.resource) ? eventObj.resource._resource.title : null;
                }
                if ($('#search-form-mode_vehicle').hasClass('active')) {
                    data.vehicle_id = (eventObj.resource) ? eventObj.resource._resource.id : null;
                    data.vehicle_name = (eventObj.resource) ? eventObj.resource._resource.title : null;
                }
                timeline.openModal(eventObj, data);
            });
            // click event data
            timeline._calendar.setOption('eventClick', function (eventObj) {
                // close popover
                $(eventObj.el).popover('hide');
                // open setting modal
                let data = {
                    id: eventObj.event.id,
                };
                timeline.openModal(eventObj, data);
            });
            // drop event data
            timeline._calendar.setOption('eventDrop', function (eventObj) {
                let data = null;
                if(eventObj.newResource) {
                    // リソースの変更があった場合
                    // ex) 社員タブの場合、社員が変わった際の処理
                    data = {
                        id: eventObj.event.id,
                        start: eventObj.event.startStr,
                        end: eventObj.event.endStr,
                        section_id: (eventObj.newResource) ? eventObj.newResource._resource.extendedProps.section_id : null,
                        section_name: (eventObj.newResource) ? eventObj.newResource._resource.extendedProps.section_name : null,
                        is_drop: true
                    };
                    if ($('#search-form-mode_user').hasClass('active')) {
                        data.user_id = (eventObj.newResource) ? eventObj.newResource._resource.id : null;
                        data.user_name = (eventObj.newResource) ? eventObj.newResource._resource.title : null;
                    }
                    if ($('#search-form-mode_vehicle').hasClass('active')) {
                        data.vehicle_id = (eventObj.newResource) ? eventObj.newResource._resource.id : null;
                        data.vehicle_name = (eventObj.newResource) ? eventObj.newResource._resource.title : null;
                    }
                    if (eventObj.event.extendedProps.vehicle_id) {
                        data.vehicle_id = eventObj.event._def.resourceIds[0];
                    }
                } else {
                    // リソースの変更がない場合
                    // ex) 社員タブの場合、社員が変わらず日時のみの変更時の処理
                    data = {
                        id: eventObj.event.id,
                        start: eventObj.event.startStr,
                        end: eventObj.event.endStr,
                        section_id: (eventObj.oldEvent) ? eventObj.oldEvent._def.extendedProps.section_id : null,
                        section_name: (eventObj.oldEvent) ? eventObj.oldEvent._def.extendedProps.section_name : null,
                        is_drop: true
                    };
                    if ($('#search-form-mode_user').hasClass('active')) {
                        data.user_id = (eventObj.oldEvent) ? eventObj.oldEvent._def.resourceIds[0] : null;
                        data.user_name = (eventObj.oldEvent) ? eventObj.oldEvent._def.title : null;
                    }
                    if ($('#search-form-mode_vehicle').hasClass('active')) {
                        data.vehicle_id = (eventObj.oldEvent) ? eventObj.oldEvent._def.resourceIds[0] : null;
                        data.vehicle_name = (eventObj.oldEvent) ? eventObj.oldEvent._def.title : null;
                    }
                    if (eventObj.event.extendedProps.vehicle_id) {
                        data.vehicle_id = eventObj.event._def.resourceIds[0];
                    }
                }
                timeline.openModal(eventObj, data);
            });
            // resize start event data
            timeline._calendar.setOption('eventResizeStart', function (eventObj) {
                $('div.popover').hide();
                $(eventObj.el).popover('disable');
            });
            // resize stop event data
            timeline._calendar.setOption('eventResizeStop', function (eventObj) {
                $(eventObj.el).popover('update');
            });
            // resize event data
            timeline._calendar.setOption('eventResize', function (eventObj) {
                let data = {
                    id: eventObj.event.id,
                    start: eventObj.event.startStr,
                    end: eventObj.event.endStr,
                };
                if (eventObj.event.extendedProps.hasOwnProperty('user_id')) {
                    data.user_id = eventObj.event._def.resourceIds[0];
                }
                if (eventObj.event.extendedProps.hasOwnProperty('vehicle_id')) {
                    data.vehicle_id = eventObj.event._def.resourceIds[0];
                }
                timeline.openModal(eventObj, data);
            });
        },

        /*---- カレント情報更新 ----*/
        currentInfo: function() {
            if (timeline._calendar.hasOwnProperty('isRendered')) {
                let inputStart = new Date().toISOString();
                if (document.querySelector("input[name=started_at]").value) {
                    inputStart = new Date(document.querySelector("input[name=started_at]").value);
                }
                timeline._currentDate = inputStart;
                timeline._currentView = timeline._calendar.view.type;
                if ($('.fc-timeline-slots').length > 0) {
                    timeline._scrollX = document.querySelector('.fc-timeline-slots').parentNode.parentNode.scrollLeft;
                    timeline._scrollY = document.querySelector('.fc-timeline-slots').parentNode.parentNode.scrollTop;
                }
            }
        },

        /*---- モーダル表示 ----*/
        openModal: function(eventObj, data) {
            $('div.popover').hide();
            $(eventObj.el).popover('enable');
            let action = extend_url_query(timeline._calendarEl.data('action'));
            let modalId = timeline._calendarEl.data('modal');
            let submit = timeline._calendarEl.data('submit');
            // モーダルのコンテンツを空に
            $('#' + modalId + ' .modal-content').empty();
            // 送信
            _ajax.post(action, data, function (results) {
                $('#' + modalId + ' .modal-content').html(results);
                initialize();
                syncVehicleReservationRecurrenceUI(modalId);
                setRecurrenceEndedOnLimits(modalId);
                _modal.show('#' + modalId);
                // // 未割当リストの表示状態を保持しておく
                // $('[' + submit + ']').data('drawer_open', $('#drawer-content').is(':visible'));
            }, function (xhr, status, errorThrown) {
                _error.omitted(xhr, status, errorThrown);
            }, 'html');
        },
    }

    // KEYWORD検索フォーム初期化
    if ($("#resourceTimelineDay-calendar").length === 0) {
        $('.navbar-search-block').removeClass('d-none');
    } else {
        $('#toolbar-keyword-search').val('');
        $('.navbar-search-block').addClass('d-none');
    }

    // load_contents--カレンダー再描画処理のため、共通の検索用イベントをOFF
    $(document).off('change', '#search-form, #toolbar-keyword-search');
    $(document).off('click', '#toolbar-keyword-search-submit, #toolbar-keyword-search-reset');

    // イベント再登録(callbackにsetCalendar処理をCALLする)
    $(document).on('change', '#search-form, #toolbar-keyword-search', function () {
        // let open = $('#drawer-content').is(':visible');
        timeline.currentInfo();
        // コンテンツを読込
        load_contents(function () {
            timeline.setCalender();
            // drawer.toggle(open);
            setTimeout(function () {
                if ($("#resourceTimelineDay-calendar").length === 0) {
                    $('.navbar-search-block').removeClass('d-none');
                } else {
                    $('.navbar-search-block').addClass('d-none');
                }
            }, 10);
        }, false);
    });

    $(document).on('click', '#toolbar-keyword-search-submit, #toolbar-keyword-search-reset', function () {
        // let open = $('#drawer-content').is(':visible');
        timeline.currentInfo();
        // コンテンツを読込
        load_contents(function () {
            timeline.setCalender();
            // drawer.toggle(open);
        }, false);
    });

    // グループ会社変更時
    $(document).on('change', '#search-form-holding_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            location.href = action;
            return false;
        }
        let excutionData = [];
        excutionData.push('company_id', 'section_id', 'page');
        action = _request.create_affiliation_url(action, true, [{'name': 'holding_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    // 会社変更時
    $(document).on('change', '#search-form-company_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            location.href = action;
            return false;
        }
        let excutionData = [];
        excutionData.push('section_id', 'page');
        action = _request.create_affiliation_url(action, true, [{'name': 'company_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    // 営業所変更時
    $(document).on('change', '#search-form-section_id', function () {
        var action = $('#search-form').attr('action').replace('/list', '');
        if($(this).val() == ''){
            let urlString = new URL(location.href);
            urlString.searchParams.delete('section_id');
            location.href = urlString;
            return false;
        }
        let excutionData = [];
        excutionData.push('section_id', 'page');
        action = _request.create_affiliation_url(action, true, [{'name': 'section_id', 'value': $(this).val()}], excutionData);
        location.href = action;
        return false;
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function (e) {
        vehicleReservationSubmitSave($(this), false, false);
    });

    // 設定保存キャンセル時
    $(document).on('click', '[data-dismiss]', function () {
        timeline.setCalender();
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function (e) {
        const $form = $('#vehicle_reservation-setting-modal-form');
        if (isEditRecurrenceReservation($form)) {
            // 繰り返し車両予約変更確認モーダル表示
            openApplyScopeConfirmModal('delete', $(this), $form);
            return;
        }

        _modal.submit(this, 'delete-modal', function(results) {
            // カレンダー更新
            timeline.setCalender();
        });
    });

    // load
    $('#search-form').trigger('change');

    /*---- 車両予約 繰り返し設定 ----*/

    // 繰り返し設定変更時
    $(document).on('change', '[name=recurrence_enabled]', function () {
        syncVehicleReservationRecurrenceUI('vehicle_reservation-setting-modal');
    });

    // 繰り返しタイプ変更時
    $(document).on('change', '#vehicle_reservation-setting-modal-recurrence_type', function () {
        syncVehicleReservationRecurrenceUI('vehicle_reservation-setting-modal');
    });

    // 予約日時(開始)変更時
    $(document).on('change', '#vehicle_reservation-setting-modal-reserve_started_at', function () {
        const date = $(this).val().trim();
        if (!date) return;

        // 「/」区切りで統一
        const normalized = date.replace(/[-.]/g, '/');
        const dateObj = new Date(normalized);
        if (isNaN(dateObj.getTime())) {
            return;
        }

        // 変更後の日・曜日を取得
        const weekday = String(dateObj.getDay());
        const dayOfMonth = dateObj.getDate();

        const $modal = $('#vehicle_reservation-setting-modal');
        const weekdaysName = 'recurrence_weekdays[]';
        const dayOfMonthName = 'recurrence_day_of_month';

        // 選択されている曜日
        const selectedWeekdays = getCurrentRecurrenceWeekdays($modal);
        // 選択されている曜日に変更後の曜日が含まれていない場合のみ変更
        if (!selectedWeekdays.includes(weekday)) {
            $modal.find(`[name="${weekdaysName}"]`).val([weekday]);
            $modal.find(`[name="${weekdaysName}"]`).closest('label').removeClass('active');
            $modal.find(`[name="${weekdaysName}"][value="${weekday}"]`).click();
        }

        // 毎月の日付変更
        $modal.find(`[name=${dayOfMonthName}]`).val(dayOfMonth).trigger('change');
    });

    // 曜日の文字列を配列に変換
    function parseWeekdaysValue(value) {
        if (!value) {
            return [];
        }

        return String(value)
            .split(',')
            .map(function (v) { return String(v).trim(); })
            .filter(function (v) { return v !== ''; })
            .sort();
    }

    // 二つの配列が同じ配列か
    function isSameArray(left, right) {
        if (left.length !== right.length) {
            return false;
        }
        for (let i = 0; i < left.length; i++) {
            if (left[i] !== right[i]) {
                return false;
            }
        }
        return true;
    }

    // 日付を表示用フォーマットに変換
    function formatDatetimeForDisplay(value, format = 'yyyy/mm/dd hh:mm') {
        if (!value) {
            return '';
        }
        if (!(value instanceof Date) && typeof value !== 'string') {
            return value;
        }
        const d = new Date(value);
        if (isNaN(d.getTime())) {
            return value;
        }
        const pad = function (n) {
            return ('0' + n).slice(-2);
        };

        const yyyy = d.getFullYear();
        const mm   = pad(d.getMonth() + 1);
        const dd   = pad(d.getDate());
        const hh   = pad(d.getHours());
        const min  = pad(d.getMinutes());

        const normalizedFormat = format.replace(/(:|：)mm/, '$1min');
        let result = normalizedFormat;
        result = result.replace('yyyy', yyyy);
        result = result.replace('mm', mm);
        result = result.replace('dd', dd);
        result = result.replace('hh', hh);
        result = result.replace('min', min);
        return result;
    }

    // フォームの繰り返しタイプ取得（繰り返し設定が OFF の時は 0）
    function getFormRecurrenceType($form) {
        const recurrenceEnabled = parseInt($form.find('[name=recurrence_enabled]:checked').val(), 10) === 1;
        if (!recurrenceEnabled) {
            return 0;
        }
        const $typeSelect = $form.find('[name="recurrence_type"]').not('[id$="-recurrence_type_disabled"]');
        let recurrenceType = parseInt($typeSelect.val(), 10);
        if (isNaN(recurrenceType)) {
            recurrenceType = 1;
        }
        return recurrenceType;
    }

    // 繰り返し予約項目表示制御
    function syncVehicleReservationRecurrenceUI(modalId) {
        const $modal = $(`#${modalId}`);
        if ($modal.length === 0) {
            return;
        }

        const recurrenceEnabled = parseInt($modal.find('[name=recurrence_enabled]:checked').val(), 10) === 1;
        const $recurrenceType = $modal.find(`#${modalId}-recurrence_type`);
        const $recurrenceTypeDisabled = $modal.find(`#${modalId}-recurrence_type_disabled`);
        const $recurrenceItems = $modal.find(`#${modalId}-recurrence_items`);
        if ($recurrenceType.length === 0 || $recurrenceTypeDisabled.length === 0 || $recurrenceItems.length === 0) {
            return;
        }

        $recurrenceItems.toggleClass('d-none', !recurrenceEnabled);
        // 全部非表示
        $recurrenceItems.find('.recurrence-item').addClass('d-none');
        $recurrenceItems.find(':input').prop('disabled', true);
        const currentClass = $recurrenceType.find('option:selected').data('type-class') ?? null;
        if (recurrenceEnabled && currentClass) {
            // 該当のクラスだけ表示
            const $showItems = $recurrenceItems.find(`.recurrence-item.${currentClass}`);
            $showItems.removeClass('d-none');
            $showItems.find(':input').prop('disabled', false);
        }
        $recurrenceTypeDisabled.prop('disabled', recurrenceEnabled);
        $recurrenceType.prop('disabled', !recurrenceEnabled);

        // 「祝日の繰り返し予約」文言切り替え
        const includeHolidayFlgId = `${modalId}-include_holiday_flg`;
        const $includeHolidayFlgLabels = $modal.find(`#${includeHolidayFlgId}_labels`);
        const $includeHolidayFlgLabel = $modal.find(`[for=${includeHolidayFlgId}]`);
        const label = currentClass === 'show-monthly' ? $includeHolidayFlgLabels.attr('data-weekend-label') : $includeHolidayFlgLabels.attr('data-label');
        $includeHolidayFlgLabel.text(label);
    }

    // 繰り返し終了日入力制御
    function setRecurrenceEndedOnLimits(modalId) {
        const $recurrenceEndedOn = $(`#${modalId}-recurrence_ended_on`);
        if ($recurrenceEndedOn.length === 0) {
            return;
        }
        const picker = $recurrenceEndedOn.data("datetimepicker");
        if (!picker) {
            return;
        }
        // 入力制御リセット
        picker.options({
            minDate: false,
            maxDate: false,
            useCurrent: false,
        });

        const minDateStr = formatDatetimeForDisplay($recurrenceEndedOn.data('min-date'), 'yyyy/mm/dd');
        const maxDateStr = formatDatetimeForDisplay($recurrenceEndedOn.data('max-date'), 'yyyy/mm/dd');
        const minDate = minDateStr ? new Date(minDateStr) : null;
        const maxDate = maxDateStr ? new Date(maxDateStr) : null;

        if (minDate && maxDate && !isNaN(minDate) && !isNaN(maxDate)) {
            maxDate.setHours(23, 59, 59, 999);  // その日の終端にする
            if (minDate <= maxDate) {
                picker.options({
                    minDate: minDate,
                    maxDate: maxDate,
                    useCurrent: false,  // 勝手に日付が入らないようにする
                });
            }
        }
    }

    // 選択中の繰り返し曜日設定取得
    function getCurrentRecurrenceWeekdays($form) {
        return $form.find('[name="recurrence_weekdays[]"]:checked')
            .map(function () { return String($(this).val()); })
            .get()
            .sort();
    }

    // 表示中の繰り返し予約項目に変更が入ったか
    function hasVehicleReservationRecurrenceItemChanges($form) {
        if ($form.length === 0) {
            return false;
        }

        // 繰り返し設定
        const initialEnabled = parseInt($form.find('[name=recurrence_initial_enabled]').val(), 10) === 1;
        const currentEnabled = parseInt($form.find('[name=recurrence_enabled]:checked').val(), 10) === 1;
        if (initialEnabled !== currentEnabled) {
            return true;
        }
        // 繰り返しタイプ
        const $currentType = $form.find('[name="recurrence_type"]').not('[id$="-recurrence_type_disabled"]');
        let initialType = parseInt($form.find('[name=recurrence_initial_type]').val(), 10);
        let currentType = getFormRecurrenceType($form);
        if (isNaN(initialType)) {
            initialType = 1;
        }
        if (initialType !== currentType) {
            return true;
        }
        // 繰り返しタイプから表示されている class 名を取得
        const currentClass = $currentType.find('option:selected').data('type-class') ?? null;
        // 繰り返し曜日設定
        const $currentWeekdays = $form.find('[name="recurrence_weekdays[]"]');
        if (!currentClass || $currentWeekdays.closest(`.${currentClass}`).length > 0) {
            const initialWeekdays = parseWeekdaysValue($form.find('[name=recurrence_initial_weekdays]').val());
            const currentWeekdays = getCurrentRecurrenceWeekdays($form);
            if (!isSameArray(initialWeekdays, currentWeekdays)) {
                return true;
            }
        }
        // 毎月の日付
        const $currentDayOfMonth = $form.find('[name=recurrence_day_of_month]');
        if (!currentClass || $currentDayOfMonth.closest(`.${currentClass}`).length > 0) {
            let initialDayOfMonth = parseInt($form.find('[name=recurrence_initial_day_of_month]').val(), 10);
            let currentDayOfMonth = parseInt($currentDayOfMonth.val(), 10);
            if (isNaN(initialDayOfMonth)) {
                initialDayOfMonth = 1;
            }
            if (isNaN(currentDayOfMonth)) {
                currentDayOfMonth = 1;
            }
            if (initialDayOfMonth !== currentDayOfMonth) {
                return true;
            }
        }
        // （土日・）祝日の繰り返し予約
        const $currentIncludeHolidayFlg = $form.find('[name=include_holiday_flg]');
        if (!currentClass || $currentIncludeHolidayFlg.closest(`.${currentClass}`).length > 0) {
            const initialIncludeHolidayFlg = parseInt($form.find('[name=recurrence_initial_include_holiday_flg]').val(), 10) === 1;
            const currentIncludeHolidayFlg = parseInt($currentIncludeHolidayFlg.filter(':checked').val(), 10) === 1;
            if (initialIncludeHolidayFlg !== currentIncludeHolidayFlg) {
                return true;
            }
        }
        // 繰り返し終了日
        const $currentEndedOn = $form.find('[name=recurrence_ended_on]');
        if (!currentClass || $currentEndedOn.closest(`.${currentClass}`).length > 0) {
            const initialEndedOn = formatDatetimeForDisplay($form.find('[name=recurrence_initial_ended_on]').val(), 'yyyy/mm/dd');
            const currentEndedOn = formatDatetimeForDisplay($currentEndedOn.val(), 'yyyy/mm/dd');
            if (initialEndedOn !== currentEndedOn) {
                return true;
            }
        }
        return false;
    }

    // 繰り返し車両予約編集画面か
    function isEditRecurrenceReservation($form) {
        if ($form.length === 0) {
            return false;
        }
        const id = parseInt($form.find('[name=id]').val(), 10);
        const seriesId = parseInt($form.find('[name=series_id]').val(), 10);
        return !isNaN(id) && id > 0 && !isNaN(seriesId) && seriesId > 0;
    }

    // 予約保存
    function vehicleReservationSubmitSave($btn, onlyAvailable, isSkipApplyScopeConfirm = true) {
        const $form = $($btn.data('save-modal') + '-form');
        if ($form.length === 0) {
            return;
        }

        // 繰り返し車両予約変更確認モーダル表示
        if (!isSkipApplyScopeConfirm && isEditRecurrenceReservation($form)) {
            openApplyScopeConfirmModal('save', $btn, $form);
            return;
        }

        // パラメータ制御
        const $recurrenceEnabled = $form.find('[name=recurrence_enabled]');
        const recurrenceEnabled = parseInt($recurrenceEnabled.filter(':checked').val(), 10) !== 1;
        const $applyScopeType = $form.find('[name=apply_scope_type]');
        const $onlyAvailableFlg = $form.find('[name=only_available_flg]');
        $recurrenceEnabled.prop('disabled', true);
        // 繰り返し設定が OFF の場合、可能日のみ登録フラグはパラメータに含めない
        $onlyAvailableFlg.prop('disabled', recurrenceEnabled);
        $applyScopeType.val($form.find('[name=apply_scope_type]').val() || '1');
        $onlyAvailableFlg.val(onlyAvailable ? '1' : '0');

        timeline.currentInfo();
        _error.reset();
        _ajax.submit(`#${$form.attr('id')}`, function (results) {
            $recurrenceEnabled.prop('disabled', false);
            if (results.redirect != null) {
                location.href = results.redirect;
                return;
            }

            // 重複した予約日時が返ってきた場合、繰り返し車両予約重複確認モーダル画面表示
            if (results.duplicated_dates && results.duplicated_dates.length > 0 && !onlyAvailable) {
                openDuplicateConfirmModal($btn, results.duplicated_dates);
                return;
            }

            // 重複確認後の保存で1件も登録できなかった場合
            if (
                onlyAvailable
                && Number(results.created_count) === 0
                && results.duplicated_dates
                && results.duplicated_dates.length > 0
            ) {
                // 警告メッセージを表示して終了
                const message = results.messages && results.messages.length > 0
                    ? results.messages[0]
                    : '';
                if (message) {
                    toastr.warning(message);
                }
                return;
            }

            _complete.set(results);
            // モーダル非表示
            _modal.hide('#vehicle_reservation-duplicate-modal');
            _modal.hide('#vehicle_reservation-apply-scope-modal');
            _modal.hide('#vehicle_reservation-setting-modal');
            // カレンダー更新
            load_contents(function () {
                timeline.setCalender();
            });
        }, function (xhr, status, errorThrown) {
            $recurrenceEnabled.prop('disabled', false);
            _modal.hide('#vehicle_reservation-duplicate-modal');
            _modal.hide('#vehicle_reservation-apply-scope-modal');
            _error.set($btn.data('save-modal'), xhr, status, errorThrown, false);
        });
    }

    /*---- 繰り返し車両予約変更確認モーダル ----*/

    // 保存ボタン押下時
    $(document).on('click', '#vehicle_reservation-apply-scope-modal-save', function (e) {
        const $modal = $('#vehicle_reservation-apply-scope-modal');
        const $btn = $modal.data('active-button');
        if (!$btn || $btn.length === 0) {
            return;
        }

        const $form = $($btn.data('save-modal') + '-form');
        // 変更範囲タイプ設定
        $form.find('[name=apply_scope_type]').val(getApplyScopeValue());
        vehicleReservationSubmitSave($btn, false, true);
    });

    // 削除ボタン押下時
    $(document).on('click', '#vehicle_reservation-apply-scope-modal-delete', function (e) {
        const $modal = $('#vehicle_reservation-apply-scope-modal');
        const $btn = $modal.data('active-button');
        if (!$btn || $btn.length === 0) {
            return;
        }

        const $form = $($btn.data('delete-modal') + '-form');
        // 削除範囲タイプ設定
        $form.find('[name=apply_scope_type]').val(getApplyScopeValue());

        _modal.submit($btn, 'delete-modal', function(results) {
            // カレンダー更新
            timeline.setCalender();
        });
    });

    // 選択中の変更適用範囲タイプ取得
    function getApplyScopeValue() {
        const $modal = $('#vehicle_reservation-apply-scope-modal');
        const value = $modal.find('[name=vehicle_reservation_apply_scope_type]:checked').val();
        return value ? String(value) : '1';
    }

    // 変更範囲タイプの表示制御
    function syncApplyScopeAvailability(mode, $form) {
        const $saveForm = $form || $();
        const $modal = $('#vehicle_reservation-apply-scope-modal');
        // 繰り返し車両予約編集、かつ繰り返し設定項目に変更が入ったか
        const shouldDisableThisOnly = mode === 'save'
            && isEditRecurrenceReservation($saveForm)
            && hasVehicleReservationRecurrenceItemChanges($saveForm);
        // 「この予約のみ」項目
        const $thisOnly = $modal.find('#vehicle_reservation-apply-scope-modal-apply_scope_type_this_only');

        $thisOnly.prop('disabled', shouldDisableThisOnly);
        // 「この予約のみ」が無効で、かつチェックが入っている場合、「これ以降の予約」に切り替える
        if (shouldDisableThisOnly && $thisOnly.is(':checked')) {
            $modal.find('#vehicle_reservation-apply-scope-modal-apply_scope_type_from_this').prop('checked', true);
        }
    }

    // 繰り返し車両予約変更確認モーダル表示
    function openApplyScopeConfirmModal(mode, $btn, $form) {
        const $modal = $('#vehicle_reservation-apply-scope-modal');
        const $activeBtn = $btn || null;
        const $saveForm = $form || $();
        $modal.data('active-button', $activeBtn);

        // 文言切り替え
        const $title = $modal.find('#vehicle_reservation-apply-scope-modal-title');
        $title.text(
            mode === 'save' ? $title.attr('data-save-title') : $title.attr('data-delete-title')
        );
        const $description = $modal.find('#vehicle_reservation-apply-scope-modal-description');
        $description.text(
            mode === 'save' ? $description.attr('data-save-text') : $description.attr('data-delete-text')
        );

        // 値格納
        const reservationId = $saveForm.find('[name=id]').val() || '';
        const selectedScope = $saveForm.find('[name=apply_scope_type]').val() || '1';
        $modal.find('#vehicle_reservation-apply-scope-modal-save').toggleClass('d-none', mode !== 'save');
        $modal.find('#vehicle_reservation-apply-scope-modal-delete').toggleClass('d-none', mode !== 'delete');
        $modal.find('#vehicle_reservation-apply-scope-modal-id').val(reservationId);
        $modal.find('#vehicle_reservation-apply-scope-modal-apply_scope_type').val(selectedScope);
        $modal.find('#vehicle_reservation-apply-scope-modal-apply_scope_type_this_only').prop('disabled', false);
        $modal.find(`[name=vehicle_reservation_apply_scope_type][value="${selectedScope}"]`).prop('checked', true);

        // 変更範囲タイプの表示制御
        syncApplyScopeAvailability(mode, $form);

        // 表示
        _modal.show('#vehicle_reservation-apply-scope-modal');
    }

    /*---- 繰り返し車両予約重複確認モーダル ----*/

    // 保存ボタン押下時
    $(document).on('click', '#vehicle_reservation-duplicate-modal-save', function () {
        const $btn = $('#vehicle_reservation-duplicate-modal').data('active-button');
        if (!$btn || $btn.length === 0) {
            return;
        }

        vehicleReservationSubmitSave($btn, true, true);
    });

    // 繰り返し車両予約重複確認モーダル表示
    function openDuplicateConfirmModal($btn, duplicatedDates) {
        // 重複した予約日時一覧表示
        const $list = $('#vehicle_reservation-duplicate-modal-list');
        $list.empty();
        const displayCount = Number($list.data('display-count')) || 0;
        const displayDates = duplicatedDates.slice(0, displayCount);
        displayDates.forEach(function (dates) {
            const startedAt = formatDatetimeForDisplay(dates.reserve_started_at);
            $list.append(`<li>${startedAt}～</li>`);
        });

        const $alert = $('#vehicle_reservation-duplicate-modal-alert');
        $alert.empty();
        // 省略した日時がある場合、警告表示
        const totalCount = duplicatedDates.length;
        if (totalCount > displayCount) {
            const template = $alert.attr('data-template');
            const omittedCount = totalCount - displayDates.length;
            const alert = template.replace(':total', totalCount).replace(':omitted', omittedCount);
            $alert.html(alert);
        }

        $('#vehicle_reservation-duplicate-modal').data('active-button', $btn);
        _modal.show('#vehicle_reservation-duplicate-modal');
    }
}
